import { render } from "./GrossToNet.vue?vue&type=template&id=17811216&scoped=true&ts=true"
import script from "./GrossToNet.vue?vue&type=script&lang=ts"
export * from "./GrossToNet.vue?vue&type=script&lang=ts"

import "./GrossToNet.vue?vue&type=style&index=0&id=17811216&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\paga-ime\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17811216"]])

export default __exports__